import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const baseURI = config.dashboardApiUrl;
const companyURI = config.companyApiUrl;

const dashboardStoreModule = {
  // namespaced: false,

  state: {
    dashboardDetail: [],
  },
  mutations: {
    'SET_STORE_DASHBOARD_DETAIL'(state, dashboardDetail) {
      state.dashboardDetail = dashboardDetail;
    },
  },
  actions: {
    getDashBoardDetail: async ({ commit }, params) => {
      try {
        let url = `${baseURI}/dashboard`;
        if (params.ownrId === params.compId) {
          url += `/${params.ownrId}?startTimestamp=${params.startTimestamp}&endTimestamp=${params.endTimestamp}`;
        } else {
          url += `/${params.ownrId}/${params.compId}?startTimestamp=${params.startTimestamp}&endTimestamp=${params.endTimestamp}`;
        }
        const response = await axios.get(url);
        commit('SET_STORE_DASHBOARD_DETAIL', response.data);
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    dashboardDetail: state => state.dashboardDetail,
  },
};

export default dashboardStoreModule;
